/**
 * SystemsCapabilities
 *
 * Purpose: The three ICE capabilities (turn-granular storage, multi-lane retrieval, cross-session persistence),
 * each paired with its metaphor drawing. Shared by the Home and ICE pages.
 * Data schema: Props accept headingId (string) so the parent section can label itself with the heading.
 * Copy source: content/website-copy-deck.md (ice.heading, ice.turnGranular*, ice.lanes*, ice.crossSession*).
 */
import React from "react";
import { FilmFramesGlyph, LibraryShelvesGlyph, FeedbackLoopGlyph } from "./MetaphorGlyphs";

const ITEMS = [
  {
    Glyph: FilmFramesGlyph,
    title: "Turn-granular storage",
    body: "Each conversational turn is stored as its own frame, like a frame in a film, so the order of events survives. Fixed-window chunking loses it.",
  },
  {
    Glyph: LibraryShelvesGlyph,
    title: "Multi-lane retrieval",
    body: "Retrieval is organised like the sections of a library: episodic for what happened, semantic for what it means, procedural for how to do it, and working for what the agent is focused on now.",
  },
  {
    Glyph: FeedbackLoopGlyph,
    title: "Cross-session persistence",
    body: "Memory carries across sessions, so each interaction can build on the last, like a feedback loop.",
  },
];

export const SystemsCapabilities = ({ headingId }) => (
  <>
    <h2 id={headingId} className="text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight text-balance text-[#FFFFFF] max-w-3xl mb-16">
      How ICE applies systems thinking to agent memory.
    </h2>
    <div className="grid md:grid-cols-3 gap-12 md:gap-10">
      {ITEMS.map(({ Glyph, title, body }) => (
        <div key={title}>
          <Glyph className="w-28 h-20 text-[#6FB6E8] mb-8" />
          <h3 className="text-xl font-bold tracking-tight text-[#FFFFFF] mb-3">{title}</h3>
          <p className="text-[#FFFFFF]/70 font-light leading-relaxed">{body}</p>
        </div>
      ))}
    </div>
  </>
);
